type TPromise = Promise<unknown>
type TAllSettled = typeof Promise.allSettled

//prettier-ignore
/**
 * Promise.allSettled with fallback to Promise.all
 */
export const promiseAllSettled: TAllSettled =
<TPromises extends RoA<TPromise>>
(promises: TPromises) => {
  return Promise.allSettled
  ? Promise.allSettled(promises)
  : Promise.all(promises.map(getPromiseResult))
}

// * HELPERS

// returns result of the `promise` in a Promise.allSettled-like shape
// https://stackoverflow.com/a/66673057
const getPromiseResult = <TPromises extends RoA<TPromise>>(promise: TPromises[number]) =>
  promise
    .then((value) => ({
      status: 'fulfilled' as const,
      value,
    }))
    .catch((reason) => ({
      status: 'rejected' as const,
      reason,
    }))
